module.exports = function () {
  var html = "\n          <div class=\"divorce-overlay\" id=\"divorce-overlay\">\n            <div class=\"status\">Henry VIII requests Divorce:</div>\n            <div class=\"controls\"></div>\n          </div>\n  \t";
  return html;
};